import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Textarea, Select, Toggle, ImageField, ListEditor } from "./AdminUI";
import { Plus, Edit2, Trash2 } from "lucide-react";

const CATS = ["Architecture", "Interior", "Construction", "Additional"];
const ICONS = ["Building2", "Compass", "LayoutGrid", "Sofa", "HardHat", "Hammer", "Store", "KeyRound", "PencilRuler", "Home"];
const EMPTY = { name: "", category: "Architecture", icon: "Building2", cover_image: "", short_description: "", full_description: "", full_description_align: "left", benefits: [], process: [], gallery: [], faqs: [], published: true, order: 0, seo_title: "", seo_description: "" };

export default function ServicesAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/services/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.name.trim()) return alert("Name required");
    if (editing.id) await api.put(`/services/admin/${editing.id}`, editing);
    else await api.post("/services/admin", editing);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete service?")) { await api.delete(`/services/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Services <span className="text-muted text-base">({items.length})</span></h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-service-btn"><Plus size={16} /> Add Service</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((s) => (
          <div key={s.id} className="rounded-xl2 bg-white border border-line p-4">
            <div className="text-xs text-gold font-bold uppercase">{s.category}</div>
            <h3 className="font-bold text-ink mt-1">{s.name}</h3>
            <p className="text-xs text-muted mt-1 line-clamp-2">{s.short_description}</p>
            <div className="flex gap-2 mt-3">
              <Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...s })}><Edit2 size={14} /> Edit</Btn>
              <Btn variant="danger" onClick={() => del(s.id)}><Trash2 size={14} /></Btn>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <Modal wide title={editing.id ? "Edit Service" : "Add Service"} onClose={() => setEditing(null)}>
          <div className="grid md:grid-cols-2 gap-4">
            <Input label="Service Name *" value={editing.name} onChange={(v) => setF("name", v)} />
            <Select label="Category" value={editing.category} onChange={(v) => setF("category", v)} options={CATS} />
            <Select label="Icon" value={editing.icon} onChange={(v) => setF("icon", v)} options={ICONS} />
            <Input label="Order" type="number" value={editing.order} onChange={(v) => setF("order", parseInt(v) || 0)} />
          </div>
          <div className="mt-4"><ImageField label="Cover Image" value={editing.cover_image} onChange={(v) => setF("cover_image", v)} folder="gnons/services/" /></div>
          <div className="grid gap-4 mt-4">
            <Textarea label="Short Description" value={editing.short_description} onChange={(v) => setF("short_description", v)} />
            <Textarea label="Full Description" value={editing.full_description} onChange={(v) => setF("full_description", v)} rows={4} align={editing.full_description_align} onAlign={(v) => setF("full_description_align", v)} />
            <ListEditor label="Benefits" items={editing.benefits} onChange={(v) => setF("benefits", v)} />
            <ListEditor label="Process Steps" items={editing.process} onChange={(v) => setF("process", v)} />
          </div>
          <div className="mt-4"><Toggle label="Published" checked={editing.published} onChange={(v) => setF("published", v)} /></div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-service-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
